import { render, staticRenderFns } from "./FaqTwo.vue?vue&type=template&id=11c831b5"
import script from "./FaqTwo.vue?vue&type=script&lang=js"
export * from "./FaqTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports